import { Text, TextProps } from '@react-pdf/renderer';

export function TermsAndConditions(props?: TextProps) {
  return (
    <Text {...props}>
      Standard terms and conditions can be found on
      https://www.mwcomponents.com/terms-and-conditions
    </Text>
  );
}
